import { Badge, Flex, Text, forwardRef } from "@chakra-ui/react";
import { Button, ButtonProps } from "src/components/base/button";
import { IconCaret } from "src/components/icons";

interface IPopoverButton extends Omit<ButtonProps, "colorScheme"> {
    title: string;
    isOpen: boolean;
    badgeInfo?: string;
}

export const PopoverButton = forwardRef<IPopoverButton, typeof Button>(({ title, badgeInfo, isOpen, ...buttonProps }, ref) => (
    <Button
        border="1px solid"
        borderColor="gray.300"
        display="flex"
        justifyContent="space-between"
        {...buttonProps}
        ref={ref}
        colorScheme="whiteAlpha"
        rightIcon={<IconCaret boxSize={3} transition="transform 0.3s" transform={isOpen ? "rotate(180deg)" : undefined} />}
    >
        <Flex>
            <Text alignSelf="center" fontSize="sm">
                {title}
            </Text>
            {badgeInfo && (
                <Badge ml={1} variant="solid" size="sm" colorScheme="blackAlpha" fontSize="xs">
                    {badgeInfo}
                </Badge>
            )}
        </Flex>
    </Button>
));
